/**
 * TCMS anchor location jumper
 *
 * @version 1.0.0
 */

function isValidHash(hashValue: string): boolean {
    const hashRegex = /^#[A-Za-z_][A-Za-z0-9._:-]*$/;

    return hashRegex.test(hashValue);
}

function getAnchorTargetElement(): HTMLElement | null {
    const hashValue = window.location.hash;

    return isValidHash(hashValue) ? document.querySelector<HTMLElement>(hashValue) : null;
}

async function loadAllImages(): Promise<void> {
    const unloadedImages = Array.from(document.querySelectorAll<HTMLImageElement>('.lazyload'));

    if (unloadedImages.length === 0) return;

    unloadedImages.forEach((img) => {
        const imgSrc = img.getAttribute('data-src');

        if (imgSrc) {
            img.classList.remove('lazyload');
            img.src = imgSrc;
            img.loading = 'eager';
        }
    });

    await Promise.all(
        unloadedImages.map((img) => {
            if (img.complete) {
                return Promise.resolve();
            } else {
                new Promise((resolve) => {
                    img.addEventListener('load', resolve, { once: true });
                    img.addEventListener('error', resolve, { once: true });
                });
            }
        })
    );
}

async function scrollToAnchor(): Promise<void> {
    const anchorTargetElement = getAnchorTargetElement();

    if (!anchorTargetElement) {
        return;
    }

    if (typeof window.fireAllVisible === 'function') {
        await window.fireAllVisible();
    }

    await loadAllImages();

    if (typeof window.scrollToTarget === 'function') {
        const scrollOffsetHeight = 45;
        const isShrinkedView = document.documentElement.clientWidth < 1025;
        const isFloatingHeadBar = !!document.querySelector('#content .tcms_floating_sidebar');
        const scrollOffset = isShrinkedView && isFloatingHeadBar ? scrollOffsetHeight : 0;

        window.scrollToTarget(anchorTargetElement, window, -scrollOffset);
    }
}

if (document.readyState === 'complete') {
    scrollToAnchor();
} else {
    window.addEventListener('load', scrollToAnchor);
}

// Debounced hashchange event to prevent excessive calls
let hashChangeTimeout: NodeJS.Timeout | null = null;

window.addEventListener('hashchange', () => {
    if (hashChangeTimeout) clearTimeout(hashChangeTimeout);
    hashChangeTimeout = setTimeout(() => scrollToAnchor(), 100);
});
